import { ranking } from '@/mocks/home';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-white',
  2: 'bg-primary-400 text-white',
  3: 'bg-secondary-500 text-white',
};

const changeIcon: Record<string, string> = {
  up: 'text-accent-600',
  down: 'text-foreground-400',
  new: 'text-primary-600',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">今日热度榜</h2>
          <p className="text-sm text-foreground-600">全网吃瓜话题实时热度排名</p>
        </div>
        <div className="max-w-[800px] mx-auto bg-background-50 rounded-2xl overflow-hidden">
          {ranking.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                idx < ranking.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate">{item.title}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.heat}</span>
                <span className={`w-5 h-5 flex items-center justify-center ${changeIcon[item.change]}`}>
                  <i className={`${item.icon} text-xs`}></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}